import React, {Component} from 'react';
import {Map, TileLayer, Marker} from 'react-leaflet';
import L from 'leaflet';

const iconPerson = new L.Icon({
  iconUrl: '/pin.png',
  iconRetinaUrl: '/pin.png',
  iconSize: new L.Point(37, 37),
  className: 'map-position',
});
const MyMarker = (props: any) => {
  const initMarker = (ref: any) => {
    if (ref) {
      ref.leafletElement.openPopup();
    }
  };

  return <Marker draggable ref={initMarker} {...props} icon={iconPerson} />;
};

class MapPosition extends Component

  <{
    zoom: number;
    center: any;
    position: any;
    setLatlng: any;
    style?: object;
  }
    ,
    any> {
  constructor(props: any) {
    super(props);
    this.state = {
      currentPos: props.position,
    } as any;
  }

  handleClick = (e: any) => {
    this.setState({currentPos: e.latlng});
    this.props.setLatlng(e.latlng);
  };

  render() {
    return (
      <div>
        <Map
          style={this.props.style ? this.props.style : {}}
          center={this.props.center}
          zoom={this.props.zoom}
          onClick={this.handleClick}
        >
          <TileLayer url="https://{s}.tile.osm.org/{z}/{x}/{y}.png" />
          {this.state.currentPos && (
            <MyMarker position={this.state.currentPos}></MyMarker>
          )}
        </Map>
      </div>
    );
  }
}

export default MapPosition;
